import { fields, getDistinctValues } from "../../../omnia"
import { EditLayer } from "../edit-layer"

import CroppingLayer = fields.map.layers.CroppingLayer

export class ColorContext {

    private _colors: number[][]

    private _croppingStyle: omnia.datalayers.CroppingStyle
    private _fieldColors: { [key: number]: number[] } = {}
    private _showFieldColors: boolean

    constructor(private layer: EditLayer, croppingLayer: CroppingLayer) {

        this._croppingStyle = new omnia.datalayers.CroppingStyle(croppingLayer)
        croppingLayer.styleProvider = s => this._croppingStyle.getLayerStyleFunction(s)

        this.refreshColors()

        this.initCustomFieldColors()
        this._showFieldColors = this.hasFieldColors()

        this.refreshCroppingLayer()

    }

    hasFieldColors() {
        return !!Object.keys(this._fieldColors).length
    }

    refreshColors(reset?: boolean) {

        const init = reset ? [] : (this._colors || [])

        const allColors = this.layer.zones
            .concat(this.layer.getFieldZones())
            .filter(e => e.fillColor)
            .map(e => e.fillColor)
            .concat(init)
            .map(c => ({
                color: c,
                id: omnia.color.colorToCss(c)
            }))

        const colors = getDistinctValues(allColors, c => c, c => c.id)
            .map(c => ({
                color: c.color,
                hsl: omnia.color.rgbToHslArray(c.color)
            }))
            .sort((c1, c2) => {

                const h = c1.hsl[0] - c2.hsl[0]
                if (h) return h

                const s = c1.hsl[1] - c2.hsl[1]
                if (s) return s

                return c1.hsl[2] - c2.hsl[2]

            })
            .map(c => c.color)

        this._colors = colors

    }

    get colors() {
        return this._colors.slice()
    }

    get customFieldColors() {
        return this._showFieldColors
    }

    set customFieldColors(value) {
        this._showFieldColors = value
        this.refreshCroppingLayer()
    }

    public refreshFieldColors(changeOption?: boolean) {

        this.initCustomFieldColors()

        if (changeOption) {
            this._showFieldColors = this.hasFieldColors()
        }

        this.refreshCroppingLayer()

    }

    private refreshCroppingLayer() {
        this._croppingStyle.refresh(this._showFieldColors ? this._fieldColors : undefined)
    }

    private initCustomFieldColors(reset?: boolean) {
        this._fieldColors = this.layer.getFieldColors() || []
    }

    colorToCss(color: number[]) {
        return omnia.color.colorToCss(color)
    }

    compareColors(c1: number[], c2: number[]) {
        if (!c1) return !c2
        if (!c2) return false
        if (c1.length != c2.length) return false
        return c1.every((v, i) => v == c2[i])
    }

    useLightTextColor(color: number[]) {
        return omnia.color.getWhiteBlackForegroundFromBackgroundColor(color)
    }

}

